<template>
  <div :id="componentId" class="sp1-review-section" :style="sectionStyle">
    <div class="gallery">
      <img
        class="arrow arrow-left"
        referrerpolicy="no-referrer"
        src="../assets/img/FigmaDDSSlicePNG99bb8919a69e1287d3f76ac4a83127c7.png"
        @click="prev"
      />
      <div class="gallery-track">
        <div
          v-for="(item, idx) in items"
          :key="idx"
          class="gallery-item"
          :class="[getItemClass(idx), { 'is-link': item.jumpType === 2 }]"
          :style="getItemStyle(idx)"
          @click="handleClick(item)"
        >
          <img
            class="gallery-image"
            referrerpolicy="no-referrer"
            :src="item.imageUrl"
          />
        </div>
      </div>
      <img
        class="arrow arrow-right"
        referrerpolicy="no-referrer"
        src="../assets/img/FigmaDDSSlicePNG33a817cb60e4551109bd46ed91b16c20.png"
        @click="next"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_11'
    }
  },
  data() {
    return {
       activeIndex: 3,
      backgroundColor: '#FFFFF0',
      items: [
        {
          imageUrl: require('../assets/img/review_banner.png'),
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../assets/img/review_banner.png'),
          jumpType: 2,
          linkAddress: 'https://www.example.com/review/2'
        },
        {
          imageUrl: require('../assets/img/review_banner.png'),
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../assets/img/review_banner.png'),
          jumpType: 2,
          linkAddress: 'https://www.example.com/review/4'
        },
        {
          imageUrl: require('../assets/img/review_banner.png'),
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../assets/img/review_banner.png'),
          jumpType: 2,
          linkAddress: 'https://www.example.com/review/6'
        },
        {
          imageUrl: require('../assets/img/review_banner.png'),
          jumpType: 1,
          linkAddress: ''
        }
      ]
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px',
         padding: '20px 300px',
        boxSizing: 'border-box'
      };
    },
    titleGroupStyle() {
      return {
        margin: '0px auto 0',
        width: '360px',
        height: '70px',
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    }
  },
  methods: {
    prev() {
      this.activeIndex = (this.activeIndex - 1 + this.items.length) % this.items.length;
    },
    next() {
      this.activeIndex = (this.activeIndex + 1) % this.items.length;
    },
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return;
      window.open(item.linkAddress, '_blank');
    },
    getItemClass(idx) {
      const diff = idx - this.activeIndex;
      if (diff === 0) return 'active';
      if (Math.abs(diff) === 1) return 'side';
      if (Math.abs(diff) === 2) return 'far';
      if (Math.abs(diff) === 3) return 'edge';
      return 'hidden';
    },
    getItemStyle(idx) {
      const diff = idx - this.activeIndex;
      const styles = {
        transform: 'translateX(-50%)',
        zIndex: 0,
        opacity: 0
      };
      if (diff === 0) {
        styles.transform = 'translateX(-50%) scale(1)';
        styles.zIndex = 10;
        styles.opacity = 1;
      } else if (diff === -1) {
        styles.transform = 'translateX(calc(-50% - 210px)) scale(0.74)';
        styles.zIndex = 8;
        styles.opacity = 0.95;
      } else if (diff === 1) {
        styles.transform = 'translateX(calc(-50% + 210px)) scale(0.74)';
        styles.zIndex = 8;
        styles.opacity = 0.95;
      } else if (diff === -2) {
        styles.transform = 'translateX(calc(-50% - 380px)) scale(0.56)';
        styles.zIndex = 6;
        styles.opacity = 0.85;
      } else if (diff === 2) {
        styles.transform = 'translateX(calc(-50% + 380px)) scale(0.56)';
        styles.zIndex = 6;
        styles.opacity = 0.85;
      } else if (diff === -3) {
        styles.transform = 'translateX(calc(-50% - 510px)) scale(0.42)';
        styles.zIndex = 4;
        styles.opacity = 0.7;
      } else if (diff === 3) {
        styles.transform = 'translateX(calc(-50% + 510px)) scale(0.42)';
        styles.zIndex = 4;
        styles.opacity = 0.7;
      }
      return styles;
    }
  }
};
</script>

<style scoped>
.sp1-review-section {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 30px;
  padding-bottom: 30px;
}

.sp1-group_69 .sp1-text_9 {
  margin: 0;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1;
}

.gallery {
  position: relative;
  width: 1400px;
  height: 420px;
  margin: 30px auto 0;
}

.gallery-track {
  position: relative;
  width: 100%;
  height: 100%;
}

.gallery-item {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 680px;
  height: 382px;
  margin-top: -191px;
  transition: all 0.4s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.gallery-item.is-link {
  cursor: pointer;
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.arrow {
  position: absolute;
  top: 50%;
  width: 46px;
  height: 46px;
  margin-top: -23px;
  z-index: 30;
  cursor: pointer;
}

.arrow-left {
  left: 0;
}

.arrow-right {
  right: 0;
}
</style>
